import * as React from "react";

import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import KitchenOrderCard from '../components/KitchenOrderCard.jsx'

import * as ApiCall from '../ApiCall.jsx';

// page to show all orders which have all of their dishes fully cooked
// then allows chef to uncook a meal if they made a mistake 
// or the order is sent back to the kitchen etc.
export default function KitchenComplete() {

  const [orders, setOrders] = React.useState([]);
  const [state, setState] = React.useState("loading");

  //refresh period before checking with the backend again
  const NOTIFICATION_INTERVAL = 5000;

  function getComplete() {
    ApiCall.get("/kitchen/completedOrders")
    .then((recievedOrders) => {
  
      let orderList = []
      for (let i = 0; i < recievedOrders.length; i++) {
        orderList.push(recievedOrders[i]);
      }

      // sort by newest order
      // most recent complete at top as its most liekely to be the one sent back
      orderList.sort((a, b) => {
        return (new Date(b.startTime) - new Date(a.startTime));
      });

      setOrders(orderList);
      setState("success");
      
    })
    .catch((msg) => {
      alert("Failed to get complete orders: " + msg);
    })
  }
  // for the first render as otherwise it si "loading" until the first
  // NOTIFICATION_INTERVAL period has passed
  React.useEffect(() => { 
    getComplete();
  }, []);

  //reload each interval
  React.useEffect(() => {
    const interval = setInterval(() => {
      getComplete();
    }, NOTIFICATION_INTERVAL);

    return () => clearInterval(interval);
  }, []);


  if (state === "loading") {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    )
  }

  else if (state === "success") {
    return (
      <Container sx={{display: 'flex', flexDirection: 'column', alignItems: 'center' , gap: 1, pt: 2}}>
        {
          orders.map((order) => (
            <KitchenOrderCard key={order.id} orderInfo={order} ></KitchenOrderCard>
          ))
        }
      </Container>
    );
  }
  
  
};